export default __webpack_public_path__ + "static/media/chevronDownBlue.abaf2dae.svg";